import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';

import "./SearchbarSection.css";

const SearchbarSection = () => {
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const handleSearch = () => {
    if (keyword.trim()) {
      navigate(`/search-vehicles?keyword=${encodeURIComponent(keyword)}`);
    }
  };

  return (
    <div className="searchbar-section">
      <div variant="custom-teal" className="search-button">
        Search Car
      </div>
      <input
        type="text"
        className="form-control"
        placeholder="Enter car name, model, VIN, or year"
        value={keyword}
        onChange={(e) => setKeyword(e.target.value)}
      />
      <button
        className="icon-button"
        onClick={handleSearch}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" className="searchicon" fill="currentColor" viewBox="0 0 16 16">
          <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
        </svg>
      </button>

    </div>
  );
};

export default SearchbarSection;